module.exports = __webpack_public_path__ + "img/ปลาเทอเบิท.b65d88a4.jpeg";